import { axios } from '../../config/plugins/axios';
const API_PATH = 'api';
const API_URL = `${process.env.VUE_APP_API_URL}/${API_PATH}`;

const url = (endpoint) => {

    let route = endpoint;
    return `${API_URL}/${route}`;
};

const options = (params, headers) => ({
    headers: headers || {},
    params: params || {},
});

export default {

    getApiUrl() {
        return API_URL;
    },

    get(endpoint, params, headers) {
        return axios.get(url(endpoint), options(params, headers));
    },

    post(endpoint, params, headers) {
        return axios.post(url(endpoint), params, headers);
    },

    put(endpoint, params, headers) {
        return axios.put(url(endpoint), params, headers);
    },

    patch(endpoint, params, headers) {
        return axios.patch(url(endpoint), params, headers);
    },

    delete(endpoint, params, headers) {
        return axios.delete(url(endpoint), options(params, headers));
    },

    getFile(endpoint, onDownloadProgress) {
        return axios(endpoint.startsWith('http') ? endpoint : url(endpoint), {
            responseType: 'blob',
            onDownloadProgress,
        });
    },
};

export { url };